import React, { useCallback } from "react";
import { ReactLenis } from "lenis/react";
import { SiteContentProvider, useSiteContent } from "../context/SiteContentContext";
import { Navbar } from "../components/site/Navbar";
import { Hero } from "../components/site/Hero";
import { EditorialMarquee } from "../components/site/EditorialMarquee";
import { Philosophy } from "../components/site/Philosophy";
import { Services } from "../components/site/Services";
import { ProductShowcase } from "../components/site/ProductShowcase";
import { WhyBuildRaq } from "../components/site/WhyBuildRaq";
import { Process } from "../components/site/Process";
import { TechStack } from "../components/site/TechStack";
import { CaseStudies } from "../components/site/CaseStudies";
import { Testimonials } from "../components/site/Testimonials";
import { FounderStory } from "../components/site/FounderStory";
import { FAQ } from "../components/site/FAQ";
import { Contact } from "../components/site/Contact";
import { Footer } from "../components/site/Footer";

const SECTION_COMPONENTS = [
  { key: "marquee", Comp: EditorialMarquee },
  { key: "philosophy", Comp: Philosophy },
  { key: "services", Comp: Services },
  { key: "products", Comp: ProductShowcase },
  { key: "why", Comp: WhyBuildRaq },
  { key: "process", Comp: Process },
  { key: "tech", Comp: TechStack },
  { key: "case-studies", Comp: CaseStudies },
  { key: "testimonials", Comp: Testimonials },
  { key: "founder", Comp: FounderStory },
  { key: "faq", Comp: FAQ },
];

function PublicSiteInner() {
  const { settings } = useSiteContent();
  const sections = settings?.sections || {};
  const schedulerUrl = settings?.scheduler_url || "";

  const scrollToId = useCallback((id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  const handleBookCall = useCallback(() => {
    if (schedulerUrl) {
      window.open(schedulerUrl, "_blank", "noopener,noreferrer");
    } else {
      scrollToId("#contact");
    }
  }, [schedulerUrl, scrollToId]);

  const handleExplore = useCallback(() => scrollToId("#products"), [scrollToId]);

  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="dark min-h-screen bg-void text-foreground font-body noise selection:bg-brand/30">
        <Navbar onBookCall={handleBookCall} />
        <main>
          <Hero onBookCall={handleBookCall} onExplore={handleExplore} />
          {SECTION_COMPONENTS.map(({ key, Comp }) =>
            sections[key] === false ? null : <Comp key={key} />
          )}
          <Contact />
        </main>
        <Footer onBookCall={handleBookCall} />
      </div>
    </ReactLenis>
  );
}

export default function PublicSite() {
  return (
    <SiteContentProvider>
      <PublicSiteInner />
    </SiteContentProvider>
  );
}
